import { isEmpty, isNil } from 'ramda';

export const isNilEmpty = <T>(v: T) => isNil(v) || isEmpty(v);

export const isNotNilEmpty = <T>(v: T): v is NonNullable<T> => !isNilEmpty(v);
